import { connect } from "react-redux";
// API
import api from "api";
// Component
import CustomerDetail from "components/CustomerDetail";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setCustomerDetail,
  initCustomerDetail,
  changeTab
} from "redux/modules/customerDetail";
// Utils
import history from "utils/history";

const mapStateToProps = state => ({
  customerDetail: state.customerDetail
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  setupAttr: () => {
    const { id } = ownProps.match.params;
    history.push(`/setup_attr/${id}`, ownProps);
  },
  initCustomerDetail: () => dispatch(initCustomerDetail()),
  fetchCustomerDetail: () => {
    const { id } = ownProps.match.params;

    api
      .get(`customer_detail/${id}`)
      .then(res => {
        dispatch(setCustomerDetail(res));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeTab: (event, value) => {
    dispatch(changeTab(value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetail);



// WEBPACK FOOTER //
// ./src/containers/CustomerDetail/index.js